import React, { useState,useEffect } from "react";
import { Button, DialogActions, Grid, InputLabel, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import { instance } from "../../utils/api";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
const cl = "app-component-addticket";

function AddTicket({ onSaveTicket, handleClose,triggerRefresh,setTriggerRefresh }) {
    const [full_name, setfull_name] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [help_topic, sethelp_topic] = useState('');
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [assignee, setAssignee] = useState([]);
    const [priority, setPriority] = useState('');
    const [due_date, setDue_date] = useState(null);
    const [names, setNames] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({
        full_name: false,
        company: false,
        email: false,
        subject: false,
        help_topic: false,
        phone: false,
        priority:false,
        // Add more fields as needed
    });
    // useEffect(() => {
    //   async function fetchAgentNames() {
    //       try {
    //           const response = await instance.get("agents/list");
    //           if (response.status === 200) {
    //             setTriggerRefresh(prev => prev + 1)
    //               const agentData = response.data;
    //               const name = agentData.map((agent) => agent.name);
    //               setNames(name);
                  
    //           } else {
    //               console.error("Failed to fetch agent data");
    //           }
    //       } catch (error) {
    //           console.error("Network error:", error);
    //       }
    //   }
    //   fetchAgentNames();
    // }, []);
    const username = localStorage.getItem("username")
    const handleSubmit = async (event) => {
        event.preventDefault();
        const errors = {};

        if (!full_name) {
            errors.full_name = true;
        }

        if (!company) {
            errors.company = true;
        }

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errors.email = true;
        }


        if (!subject) {
            errors.subject = true;
        }
        if (!help_topic) {
            errors.help_topic = true;
        }
        if (phone && !/^\d{10}$/.test(phone)) {
            errors.phone = true;
        }
        if(!priority){
            errors.priority=true;
        }
        setFieldErrors(errors);
        if (!full_name || !company || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || !help_topic || !subject || (phone && errors.phone) || !priority) {
            toast.error('Please fill in all required fields correctly', {
                position: 'top-right',
            });
            return;
        }

        if (Object.values(errors).some((error) => error)) {
            return;
        }


        const assigneeString = assignee.join(',');
        const formData = new FormData();
        formData.append('full_name', full_name);
        formData.append('company', company);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('help_topic', help_topic);
        formData.append('subject', subject);
        formData.append('description', description);
      
        formData.append('priority', priority);
       formData.append('raised_by',username);

        try {
            const response = await instance.post('tickets/create/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.status === 200 || response.status === 201) {
                console.log('Ticket submitted successfully');
                console.log({ triggerRefresh })
                setTriggerRefresh(prev => prev + 1)
                toast.success('Ticket submitted successfully');
                
                setfull_name('');
                setCompany('');
                setEmail('');
                setPhone('');
                sethelp_topic('');
                setSubject('');
                setDescription('');
               
                setPriority('');
           

                handleClose();

                setFieldErrors({
                    full_name: false,
                    company: false,
                    email: false,
                    subject: false,
                    help_topic: false,
                    phone: false,
                    priority:false,
                   
                });
            } 
            else {
                console.error('Failed to submit the ticket')
                toast.error('Failed to submit the ticket', {
                    position: 'top-right',
                })
            }
        } catch (error) {
            console.error('Network error:', error)

            toast.error(error.response.data.error, {
                position: 'top-right',
            })
        }
    }


    return (
        <>
            <div className={`${cl}`}>
                <div className={`${cl}__card`}>
                    <Grid container spacing={3}>
                        <Grid item md={6}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField
                                        value={full_name}
                                        onChange={(e) => setfull_name(e.target.value)}
                                        size="medium"
                                        required
                                        id="outlined-basic"
                                        label="Name"
                                        placeholder="Enter name"
                                        type="text"
                                        variant="outlined"
                                        error={fieldErrors.full_name}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={6}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField
                                        value={company}
                                        onChange={(e) => setCompany(e.target.value)}
                                        id="outlined-basic"
                                        label="Company"
                                        required
                                        placeholder="Enter company"
                                        variant="outlined"
                                        error={fieldErrors.company}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={6}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        id="outlined-basic"
                                        label="Email"
                                        placeholder="Enter email"
                                        variant="outlined"
                                        error={fieldErrors.email}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={6}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        id="outlined-basic"
                                        label="Phone"
                                        placeholder="Enter phone"
                                        variant="outlined"
                                        error={fieldErrors.phone}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={12}>
                            <div className="app-form-fields">
                                <FormControl error={fieldErrors.help_topic}  fullWidth>
                                    <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={help_topic}
                                        required
                                        label="Category"
                                        onChange={(e) => sethelp_topic(e.target.value)}
                                    >
                                        <MenuItem value={1}>Support</MenuItem>
                                        <MenuItem value={2}>Maintainance</MenuItem>
                                        <MenuItem value={3}>Payments</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={12}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                        required
                                        id="outlined-basic"
                                        label="Subject"
                                        placeholder="Enter subject"
                                        variant="outlined"
                                        error={fieldErrors.subject}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item md={12}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <TextField
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        id="outlined-basic"
                                        label="Description"
                                        multiline
                                        rows={3}
                                        placeholder="Enter description"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        {/* <Grid item md={12}>
                            <div className="app-form-fields">
                                <FormControl fullWidth>
                                    <Autocomplete
                                        id="grouped-demo"
                                        multiple
                                        options={names.map((name) => ({ label: name, value: name }))}
                                        value={assignee}
                                        onChange={(e, newValue) => setAssignee(newValue)}
                                        renderInput={(params) => <TextField placeholder="Select assignee" {...params} label="Assignee" />}
                                    />
                                </FormControl>
                            </div>
                        </Grid> */}
                        <Grid item md={12}>
                            <div className="app-form-fields">
                                <FormControl  error={fieldErrors.priority} fullWidth>
                                    <InputLabel id="demo-simple-select-label">Priority</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        value={priority}
                                        reuqired
                                        onChange={(e) => setPriority(e.target.value)}
                                        label="Priority"
                                       
                                    >
                                        <MenuItem disabled value=''>
                                            <em>
                                                Select Status
                                            </em>
                                        </MenuItem>
                                        
                                        <MenuItem value={'low'}>Low</MenuItem>
                                        <MenuItem value={'medium'}>Medium</MenuItem>
                                        <MenuItem value={'high'}>High</MenuItem>
                                        <MenuItem value={'urgent'}>Urgent</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        {/* <Grid item md={6}>
                            <div className="app-form-fields">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <FormControl fullWidth>
                                        <DatePicker
                                            label="Due Date"
                                            value={due_date}
                                            onChange={(date) => setDue_date(date)}
                                        />
                                    </FormControl>
                                </LocalizationProvider>
                            </div>
                        </Grid> */}
                        <DialogActions style={{marginLeft:'15px'}}>
                            <Button type="primary" variant="contained" autoFocus onClick={handleSubmit}>
                                Submit Ticket
                            </Button>
                        </DialogActions>
                    </Grid>
                </div>
            </div>
            <ToastContainer position="top-right" />
        </>
    );
}

export default AddTicket;

